export default {
	data() {
		return {
			apiAbortController: new AbortController()
		}
	},
	beforeDestroy() {
		if (this.apiAbortController) {
			this.apiAbortController.abort()
		}
	},
	methods: {
		/**
		 *
		 * @param error
		 *        401 Authorization required.
		 *        403 Access denied.
		 *
		 */
		apiErrorHandler(error, ok = "OK") {
			let showError = (error) => {
				// if(typeof error.text() === "function"){
				// 	console.log("has text()")
				// }
				//
				// if(typeof error.json() === "function"){
				// 	console.log("has json()")
				// }
				
				// console.log('showError', error.name, error.name === 'TypeError', error instanceof Error)
				if (typeof error === 'object') {
					this.cdvAlert(error.de || error.en || this.$t('Fehler'), error.detail || this.$t(error.message) || error, null, ok);
				}
			};
			switch (error.code) {
				case 401:
					this.$router.push('/').catch(() => null);
					break;
				case 403:
					showError(error);
					this.$router.push('/').catch(() => null);
					break;
				default:
					console.log(error)
					showError(error);
			}
		}
	}
}
